import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EventManager } from '@angular/platform-browser';

import { Observable } from 'rxjs';

/** Options for (keydown) event listener */
type Options = {
    element: any;
    keys: string;
    description: string;
};

/**
 * Create and observe keyboard shortcuts
 */
@Injectable({ providedIn: 'root' })
export class HotkeysService {
    /** A map from key combinations to their descriptions (for displaying in the help modal) */
    // TODO: Clear listeners when unsubscribed
    private hotkeys = new Map();
    /** Default options for event listeners */
    private defaults: Partial<Options> = {
        element: this.document,
    };

    constructor(
        private eventManager: EventManager,
        @Inject(DOCUMENT) private document: Document
    ) { }

    /**
     * Add a hotkey combination
     * @param options An `Options` object containing the combination of `keys` and, optionally, the `element` in the DOM the event should be attached to (defaults to `document`)
     * @returns An `Observable` emitting an update each time the hotkey combination is used
     */
    public add(options: Partial<Options>): Observable<Function> {
        const merged = { ...this.defaults, ...options };
        const event = `keydown.${merged.keys}`;

        // If a description was provided, update the hotkeys map
        merged.description && this.hotkeys.set(merged.keys, merged.description);

        return new Observable((observer) => {
            // Create handler function
            const handler = (e) => {
                e.preventDefault();
                observer.next(e);
            };
            // Add event listener based on the data from the merged (from defaults and function input) options object
            const dispose = this.eventManager.addEventListener(
                merged.element,
                event,
                handler
            );

            return () => {
                dispose();
            };
        });
    }

    openHelp() {
        console.log('HOTKEYS');
        console.table(this.hotkeys);
    }
}
